import { render } from "./attachments.vue?vue&type=template&id=6cf5652b&scoped=true"
import script from "./attachments.vue?vue&type=script&lang=js"
export * from "./attachments.vue?vue&type=script&lang=js"

import "./attachments.vue?vue&type=style&index=0&id=6cf5652b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf5652b"]])

export default __exports__